import { instanceOfGrid } from "../../../lib/grid/instanceOfGrid.js";
const flattenFilterGridItems = (filterGroup) => {
  return filterGroup.items.reduce((acc, item) => {
    if (instanceOfGrid(item)) {
      return [...acc, ...flattenFilterGridItems(item)];
    }
    return [...acc, item];
  }, []);
};
export {
  flattenFilterGridItems
};
